/* Mondo Mio - comportamento do arco de acabamento, da barra de compra fixa e do preco "Sob consulta" */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class MmArco extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.prototype.slice.call(this.querySelectorAll('.mm-finish'));
      this.imgs = Array.prototype.slice.call(this.querySelectorAll('.mm-stage__img'));
      this.stage = this.querySelector('.mm-stage');
      this.caption = this.querySelector('.mm-stage__caption');
      this.nameEl = this.querySelector('[data-mm-name]');
      this.priceEl = this.querySelector('[data-mm-price]');
      this.cta = this.querySelector('[data-mm-cta]');
      this.buttons.forEach(function (b, i) { b.addEventListener('click', function () { this.select(i); }.bind(this)); }, this);
      if (!reduce && this.stage) {
        var ticking = false;
        this.onScroll = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var r = this.getBoundingClientRect();
            var vh = window.innerHeight || 1;
            var p = Math.min(Math.max((vh - r.top) / (vh + r.height), 0), 1) - 0.5;
            var st = this.stage;
            st.style.setProperty('--mm-ty', (p * -70).toFixed(1) + 'px');
            st.style.setProperty('--mm-rot', (p * 5).toFixed(2) + 'deg');
            st.style.setProperty('--mm-sc', (1 + Math.abs(p) * 0.05).toFixed(3));
            ticking = false;
          }.bind(this));
        }.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
    }
    disconnectedCallback() { if (this.onScroll) window.removeEventListener('scroll', this.onScroll); }
    select(i) {
      var b = this.buttons[i];
      if (!b) return;
      this.buttons.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      this.imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
      if (this.stage) this.stage.style.setProperty('--mm-field', b.dataset.field);
      if (this.nameEl) this.nameEl.textContent = b.dataset.title;
      if (this.priceEl) this.priceEl.textContent = b.dataset.price;
      if (this.caption) this.caption.setAttribute('href', b.dataset.url);
      if (this.cta) { this.cta.setAttribute('href', b.dataset.url); var l = this.cta.querySelector('[data-mm-cta-label]'); if (l) l.textContent = 'Ver em ' + b.dataset.finish.toLowerCase(); }
    }
  }

  class MmStickyBuy extends HTMLElement {
    connectedCallback() {
      var id = this.getAttribute('data-target');
      this.target = id ? document.getElementById(id) : null;
      var bar = this.querySelector('.mm-sticky');
      var btn = this.querySelector('[data-mm-sticky-buy]');
      if (btn && this.target) btn.addEventListener('click', function () { this.target.click(); }.bind(this));
      if (!bar) return;
      if (!this.target || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
      this.io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.target);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  }

  if (!customElements.get('mm-arco')) customElements.define('mm-arco', MmArco);
  if (!customElements.get('mm-sticky-buy')) customElements.define('mm-sticky-buy', MmStickyBuy);

  /* Produtos de infraestrutura sao vendidos por orcamento (preco R$ 0,00 no cadastro): mostra "Sob consulta" */
  var ZERO = /^\s*R\$\s*0,00\s*$/;
  function fixPrices(root) {
    (root || document).querySelectorAll('.price-item, .price__regular, .price__sale').forEach(function (el) {
      if (el.children.length === 0 && ZERO.test(el.textContent)) {
        el.textContent = 'Sob consulta';
        el.classList.add('mm-price-quote');
      }
    });
  }
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || setTimeout)(function () { pending = false; fixPrices(); });
  }
  function init() {
    fixPrices();
    if ('MutationObserver' in window) new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
